import type { UseFormReturn } from 'react-hook-form';

import { MetricUrls } from '../../CreateMetricModal/components/MetricUrls';
import type { MetricForm } from '../../CreateMetricModal/formUtils';

import { AggregateAsField, MetricDefinitionFormField } from './MetricDefinitionFormField';

interface PageviewMetricDetailsProps {
  context: UseFormReturn<MetricForm>;
  /** Measurement window and winsorization, rendered above the definition as for custom metrics. */
  winsorizationAndWindowing?: React.ReactNode;
  /** Renders the sectioned definition band, as decided by `CreateMetricModal`. */
  useSectionedLayout?: boolean;
}

export const PageviewMetricDetails: React.FC<PageviewMetricDetailsProps> = ({
  context,
  winsorizationAndWindowing,
  useSectionedLayout = false,
}) => (
  <>
    <MetricUrls context={context} />
    {useSectionedLayout && <AggregateAsField context={context} />}
    {winsorizationAndWindowing}
    <MetricDefinitionFormField
      context={context}
      useSectionedLayout={useSectionedLayout}
      externalAggregationField={useSectionedLayout}
    />
  </>
);
